var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6406 11.5538L13.6658 11.969L13.2461 11.9181C11.7184 11.7232 10.3838 11.0623 9.25067 9.95216L8.69668 9.40135L8.55399 9.8081C8.25181 10.7148 8.44487 11.6724 9.0744 12.3164C9.41015 12.6723 9.33461 12.7232 8.75544 12.5113C8.55399 12.4435 8.37772 12.3927 8.36093 12.4181C8.30218 12.4774 8.50363 13.2486 8.66311 13.5536C8.88134 13.9773 9.32621 14.3925 9.81305 14.6383L10.2243 14.8332L9.73751 14.8417C9.26746 14.8417 9.25067 14.8501 9.30103 15.0281C9.46891 15.5789 10.132 16.1636 10.8707 16.4178L11.3911 16.5958L10.9378 16.867C10.2663 17.2568 9.4773 17.4771 8.68829 17.494C8.31057 17.5025 8 17.5364 8 17.5618C8 17.6466 9.02404 18.1211 9.61999 18.3075C11.4079 18.8584 13.5315 18.6211 15.1263 17.6805C16.2595 17.011 17.3926 15.6806 17.9214 14.3925C18.2068 13.7062 18.4922 12.452 18.4922 11.8503C18.4922 11.4605 18.5174 11.4097 18.9874 10.9436C19.2644 10.6725 19.5246 10.3759 19.575 10.2911C19.6589 10.1301 19.6505 10.1301 19.2224 10.2742C18.509 10.5284 18.4083 10.4945 18.7608 10.1132C19.021 9.842 19.3316 9.3505 19.3316 9.20645C19.3316 9.18102 19.2057 9.22339 19.063 9.29966C18.9119 9.3844 18.5761 9.51151 18.3243 9.58778L17.8711 9.73184L17.4598 9.45219C17.2331 9.29966 16.9142 9.13018 16.7463 9.07934C16.3182 8.9607 15.6635 8.97765 15.2774 9.11323C14.2282 9.49456 13.5651 10.4775 13.6406 11.5538Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter2);
export default __webpack_public_path__ + "static/media/Twitter2.0deafa31ba0b19b0bd291c174ba0ca5d.svg";
export { ForwardRef as ReactComponent };